import { UpdateBorrowerAchDetailsRow, UpdateBorrowerAchDetailsRowRefinements } from '@willow/types-iso';

import { makeValidator } from '../../shared/makeValidator';

export const validateUpdateBorrowerAchDetails = makeValidator({
  FieldParser: UpdateBorrowerAchDetailsRow,
  CrossFieldParser: UpdateBorrowerAchDetailsRowRefinements,
});
